var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Activeren Teamleader integratie...")]),_c('b-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }